import { injectable } from "inversify";

import * as gradeFilterListing from "../../public/listing/grade_filters.json";
import * as actionFilterListing from "../../public/listing/action_filters.json";

import * as lightJigsListing from "../../public/listing/light_jigs.json";
import * as singleJigsListing from "../../public/listing/single_jigs.json";
import * as begReelListing from "../../public/listing/beginner_reels.json";
import * as begSlipListing from "../../public/listing/beginner_slip_jigs.json";
import * as begHeavyListing from "../../public/listing/beginner_heavy_jigs.json";
import * as begHornListing from "../../public/listing/beginner_hornpipes.json";

import * as primReelListing from "../../public/listing/primary_reels.json";
import * as primSlipListing from "../../public/listing/primary_slip_jigs.json";
import * as primHeavyListing from "../../public/listing/primary_heavy_jigs.json";
import * as primHornListing from "../../public/listing/primary_hornpipe.json";

import * as intReelListing from "../../public/listing/intermediate_reels.json";
import * as intSlipListing from "../../public/listing/intermediate_slip_jigs.json";
import * as intHeavyListing from "../../public/listing/intermediate_heavy_jigs.json";
import * as intHornListing from "../../public/listing/intermediate_hornpipes.json";

import * as openReelListing from "../../public/listing/open_reels.json";
import * as openSlipListing from "../../public/listing/open_slip_jigs.json";
import * as openHeavyListing from "../../public/listing/open_heavy_jigs.json";
import * as openHornListing from "../../public/listing/open_hornpipes.json";

import * as tradSetListing from "../../public/listing/traditional_set_dances.json";
import * as tradHornListing from "../../public/listing/traditional_hornpipe.json";
import * as tradJigListing from "../../public/listing/traditional_heavy_jigs.json";
import * as showcaseListing from "../../public/listing/showcase_listing.json";

import * as aceAndDeuceListing from "../../public/listing/set_dances/hornpipes/ace_and_deuce_listing.json";
import * as blackbirdListing from "../../public/listing/set_dances/hornpipes/blackbird_listing.json";
import * as blueEyedRascalListing from "../../public/listing/set_dances/hornpipes/blue_eyed_rascal_listing.json";
import * as bonepartesRetreatListing from "../../public/listing/set_dances/hornpipes/bonepartes_retreat_listing.json";
import * as davisListing from "../../public/listing/set_dances/hornpipes/davis_listing.json";
import * as downfallListing from "../../public/listing/set_dances/hornpipes/downfall_listing.json";
import * as fourMastersListing from "../../public/listing/set_dances/hornpipes/four_masters_listing.json";
import * as gardenListing from "../../public/listing/set_dances/hornpipes/garden_listing.json";
import * as huntListing from "../../public/listing/set_dances/hornpipes/hunt_listing.json";
import * as jobListing from "../../public/listing/set_dances/hornpipes/job_listing.json";
import * as kilkennyListing from "../../public/listing/set_dances/hornpipes/kilkenny_listing.json";
import * as kingListing from "../../public/listing/set_dances/hornpipes/king_listing.json";
import * as lodgeListing from "../../public/listing/set_dances/hornpipes/lodge_listing.json";
import * as madameListing from "../../public/listing/set_dances/hornpipes/madame_listing.json";
import * as piperListing from "../../public/listing/set_dances/hornpipes/piper_listing.json";
import * as ramblingListing from "../../public/listing/set_dances/hornpipes/rambling_listing.json";
import * as rodneysListing from "../../public/listing/set_dances/hornpipes/rodneys_listing.json";
import * as rovingListing from "../../public/listing/set_dances/hornpipes/roving_listing.json";
import * as whiteListing from "../../public/listing/set_dances/hornpipes/white_listing.json";
import * as youghalListing from "../../public/listing/set_dances/hornpipes/youghal_listing.json";

import * as heathyListing from "../../public/listing/set_dances/hornpipes/heathy_listing.json";
import * as bradleyListing from "../../public/listing/set_dances/hornpipes/bradley_listing.json";
import * as keepListing from "../../public/listing/set_dances/hornpipes/keep_listing.json";
import * as keoghListing from "../../public/listing/set_dances/hornpipes/keogh_listing.json";

import * as blackthornListing from "../../public/listing/set_dances/jigs/blackthorn_listing.json";
import * as captainsListing from "../../public/listing/set_dances/jigs/captains_listing.json";
import * as charladyListing from "../../public/listing/set_dances/jigs/charlady_listing.json";
import * as druryListing from "../../public/listing/set_dances/jigs/drury_listing.json";
import * as fiddlerListing from "../../public/listing/set_dances/jigs/fiddler_listing.json";
import * as gaugerListing from "../../public/listing/set_dances/jigs/gauger_listing.json";
import * as hughListing from "../../public/listing/set_dances/jigs/hugh_listing.json";
import * as humoursListing from "../../public/listing/set_dances/jigs/humours_listing.json";
import * as hurlingListing from "../../public/listing/set_dances/jigs/hurling_listing.json";
import * as hurryListing from "../../public/listing/set_dances/jigs/hurry_listing.json";
import * as jockeyListing from "../../public/listing/set_dances/jigs/jockey_listing.json";
import * as missBrownsListing from "../../public/listing/set_dances/jigs/miss_browns_listing.json";
import * as orangeListing from "../../public/listing/set_dances/jigs/orange_listing.json";
import * as rubListing from "../../public/listing/set_dances/jigs/rub_listing.json";
import * as storytellerListing from "../../public/listing/set_dances/jigs/storyteller_listing.json";
import * as vanishingListing from "../../public/listing/set_dances/jigs/vanishing_listing.json";
import * as wanderingListing from "../../public/listing/set_dances/jigs/wandering_listing.json";

import * as poolListing from "../../public/listing/set_dances/jigs/pool_listing.json";
import * as ramblerListing from "../../public/listing/set_dances/jigs/rambler_listing.json";
import * as irwinListing from "../../public/listing/set_dances/jigs/irwin_listing.json";
import * as laoisListing from "../../public/listing/set_dances/jigs/laois_listing.json";
import * as dunblaneListing from "../../public/listing/set_dances/jigs/dunblane_listing.json";

import * as tradSetsListing from "../../public/listing/set_dances/traditional/trad_set_listing.json";

import * as regionFilters from "../../public/regions/region_listing.json";

import IConfigurationService from "../interfaces/configuration_service";
import ITrackFilters, { ITrack } from "../interfaces/track_filters";
import IGradeFilters from "../interfaces/grade_filters";
import IActionFilters from "../interfaces/action_filters";
import IRegions, { IRegionFilters } from "../interfaces/region_filters";
import ISpeedAndBarsFilter from "@/interfaces/speed_and_bars_filter";

@injectable()
export default class ConfigurationService implements IConfigurationService
{
	private _gradeFilters: IGradeFilters;
	private _actionFilters: IActionFilters;

	private _lightJigTracks: ITrackFilters;
	private _singleJigTracks: ITrackFilters;

	private _begReelTracks: ITrackFilters;
	private _begSlipTracks: ITrackFilters;
	private _begHeavyTracks: ITrackFilters;
	private _begHornTracks: ITrackFilters;

	private _primReelTracks: ITrackFilters;
	private _primSlipTracks: ITrackFilters;
	private _primHeavyTracks: ITrackFilters;
	private _primHornTracks: ITrackFilters;

	private _intReelTracks: ITrackFilters;
	private _intSlipTracks: ITrackFilters;
	private _intHeavyTracks: ITrackFilters;
	private _intHornTracks: ITrackFilters;

	private _openReelTracks: ITrackFilters;
	private _openSlipTracks: ITrackFilters;
	private _openHeavyTracks: ITrackFilters;
	private _openHornTracks: ITrackFilters;

	private _tradSetTracks: ITrackFilters;
	private _tradJigTracks: ITrackFilters;
	private _tradHornTracks: ITrackFilters;

	// private _setDanceFilters: ITrackFilters;

	private _regions: IRegions;
	private _selectedRegionName: string;
	private _selectedRegionProfile: any;

	private _showcaseListing: ITrackFilters;

	private _tradSetsListing: ITrackFilters;



	constructor()
	{
		console.log(`[configuration_service]: Constructor() ...Reading in config files`);
		
		this._gradeFilters = JSON.parse(JSON.stringify(gradeFilterListing));
		this._actionFilters = JSON.parse(JSON.stringify(actionFilterListing));

		this._lightJigTracks = JSON.parse(JSON.stringify(lightJigsListing));
		this._singleJigTracks = JSON.parse(JSON.stringify(singleJigsListing));

		this._begReelTracks = JSON.parse(JSON.stringify(begReelListing));
		this._begSlipTracks = JSON.parse(JSON.stringify(begSlipListing));
		this._begHeavyTracks =  JSON.parse(JSON.stringify(begHeavyListing));
		this._begHornTracks = JSON.parse(JSON.stringify(begHornListing));

		this._primReelTracks =  JSON.parse(JSON.stringify(primReelListing));
		this._primSlipTracks =  JSON.parse(JSON.stringify(primSlipListing));
		this._primHeavyTracks =  JSON.parse(JSON.stringify(primHeavyListing));
		this._primHornTracks =  JSON.parse(JSON.stringify(primHornListing));

		this._intReelTracks =  JSON.parse(JSON.stringify(intReelListing));
		this._intSlipTracks =  JSON.parse(JSON.stringify(intSlipListing));
		this._intHeavyTracks =  JSON.parse(JSON.stringify(intHeavyListing));
		this._intHornTracks =  JSON.parse(JSON.stringify(intHornListing));

		this._openReelTracks = JSON.parse(JSON.stringify(openReelListing));
		this._openSlipTracks = JSON.parse(JSON.stringify(openSlipListing));
		this._openHeavyTracks = JSON.parse(JSON.stringify(openHeavyListing));
		this._openHornTracks = JSON.parse(JSON.stringify(openHornListing));

		this._tradSetTracks = JSON.parse(JSON.stringify(tradSetListing));
		this._tradJigTracks = JSON.parse(JSON.stringify(tradJigListing));
		this._tradHornTracks = JSON.parse(JSON.stringify(tradHornListing));
		this._showcaseListing = JSON.parse(JSON.stringify(showcaseListing));

		this._tradSetsListing = JSON.parse(JSON.stringify(tradSetsListing));

		this._regions = JSON.parse(JSON.stringify(regionFilters));
		this._selectedRegionName = "not set";
		this._selectedRegionProfile = [];
	}


	private getRegionalSpeedAndBarsFilter(grade: string, category: string): ISpeedAndBarsFilter
	{
		if (!this._selectedRegionProfile)
		{
			return ({ speed: "", bars: ""});
		}
		
		switch(grade)
		{
			case "Beginner":
				switch(category)
				{
					case "Reels":
						return ({ speed: this._selectedRegionProfile[0].dances.bun.reel.speed, bars: this._selectedRegionProfile[0].dances.bun.reel.bars});
					case "Slip Jigs":
						return ({ speed: this._selectedRegionProfile[0].dances.bun.slip.speed, bars: this._selectedRegionProfile[0].dances.bun.slip.bars});
					case "Light Jigs":
						return ({ speed: this._selectedRegionProfile[0].dances.light.speed, bars: this._selectedRegionProfile[0].dances.light.bars});
					case "Single Jigs":
						return ({ speed: this._selectedRegionProfile[0].dances.single.speed, bars: this._selectedRegionProfile[0].dances.single.bars});
					case "Heavy Jigs":
						return ({ speed: this._selectedRegionProfile[0].dances.bun.heavy.speed, bars: this._selectedRegionProfile[0].dances.bun.heavy.bars});
					case "Hornpipes":
						return ({ speed: this._selectedRegionProfile[0].dances.bun.hornpipe.speed, bars: this._selectedRegionProfile[0].dances.bun.hornpipe.bars});
				}
				break;
			case "Primary":
				switch(category)
				{
					case "Reels":
						return ({ speed: this._selectedRegionProfile[0].dances.tus.reel.speed, bars: this._selectedRegionProfile[0].dances.tus.reel.bars});
					case "Slip Jigs":
						return ({ speed: this._selectedRegionProfile[0].dances.tus.slip.speed, bars: this._selectedRegionProfile[0].dances.tus.slip.bars});
					case "Light Jigs":
						return ({ speed: this._selectedRegionProfile[0].dances.light.speed, bars: this._selectedRegionProfile[0].dances.light.bars});
					case "Single Jigs":
						return ({ speed: this._selectedRegionProfile[0].dances.single.speed, bars: this._selectedRegionProfile[0].dances.single.bars});
					case "Heavy Jigs":
						return ({ speed: this._selectedRegionProfile[0].dances.tus.heavy.speed, bars: this._selectedRegionProfile[0].dances.tus.heavy.bars});
					case "Hornpipes":
						return ({ speed: this._selectedRegionProfile[0].dances.tus.hornpipe.speed, bars: this._selectedRegionProfile[0].dances.tus.hornpipe.bars});
				}
				break;
			case "Intermediate":
				switch(category)
				{
					case "Reels":
						return ({ speed: this._selectedRegionProfile[0].dances.mean.reel.speed, bars: this._selectedRegionProfile[0].dances.mean.reel.bars});
					case "Slip Jigs":
						return ({ speed: this._selectedRegionProfile[0].dances.mean.slip.speed, bars: this._selectedRegionProfile[0].dances.mean.slip.bars});
					case "Light Jigs":
						return ({ speed: this._selectedRegionProfile[0].dances.light.speed, bars: this._selectedRegionProfile[0].dances.light.bars});
					case "Single Jigs":
						return ({ speed: this._selectedRegionProfile[0].dances.single.speed, bars: this._selectedRegionProfile[0].dances.single.bars});
					case "Heavy Jigs":
						return ({ speed: this._selectedRegionProfile[0].dances.mean.heavy.speed, bars: this._selectedRegionProfile[0].dances.mean.heavy.bars});
					case "Hornpipes":
						return ({ speed: this._selectedRegionProfile[0].dances.mean.hornpipe.speed, bars: this._selectedRegionProfile[0].dances.mean.hornpipe.bars});
				}
				break;
			case "Open":
				switch(category)
				{
					case "Reels":
						return ({ speed: this._selectedRegionProfile[0].dances.ard.reel.speed, bars: this._selectedRegionProfile[0].dances.ard.reel.bars});
					case "Slip Jigs":
						return ({ speed: this._selectedRegionProfile[0].dances.ard.slip.speed, bars: this._selectedRegionProfile[0].dances.ard.slip.bars});
					case "Light Jigs":
						return ({ speed: this._selectedRegionProfile[0].dances.light.speed, bars: this._selectedRegionProfile[0].dances.light.bars});
					case "Single Jigs":
						return ({ speed: this._selectedRegionProfile[0].dances.single.speed, bars: this._selectedRegionProfile[0].dances.single.bars});
					case "Heavy Jigs":
						return ({ speed: this._selectedRegionProfile[0].dances.ard.heavy.speed, bars: this._selectedRegionProfile[0].dances.ard.heavy.bars});
					case "Hornpipes":
						return ({ speed: this._selectedRegionProfile[0].dances.ard.hornpipe.speed, bars: this._selectedRegionProfile[0].dances.ard.hornpipe.bars});
				}
				break;
		}

		return ({ speed: "", bars: ""});
	}

	private getAllTracksForGradeAndCategory(grade: string, category: string): any
	{
		const filters = this.getRegionalSpeedAndBarsFilter(grade, category);
		
		switch(grade)
		{
			case "Beginner":
				switch(category)
				{
					case "Reels":
						return this._begReelTracks.default?.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Slip Jigs":
						return this._begSlipTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Light Jigs":
						return this._lightJigTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Single Jigs":
						return this._singleJigTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Heavy Jigs":
						return this._begHeavyTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Hornpipes":
						return this._begHornTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
				}
				break;
			case "Primary":
				switch(category)
				{
					case "Reels":
						return this._primReelTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Slip Jigs":
						return this._primSlipTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Light Jigs":
						return this._lightJigTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Single Jigs":
						return this._singleJigTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Heavy Jigs":
						return this._primHeavyTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Hornpipes":
						return this._primHornTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
				}
				break;
			case "Intermediate":
				switch(category)
				{
					case "Reels":
						return this._intReelTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Slip Jigs":
						return this._intSlipTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Light Jigs":
						return this._lightJigTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Single Jigs":
						return this._singleJigTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Heavy Jigs":
						return this._intHeavyTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Hornpipes":
						return this._intHornTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
				}
				break;
			case "Open":
				switch(category)
				{
					case "Reels":
						return this._openReelTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Slip Jigs":
						return this._openSlipTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Light Jigs":
						return this._lightJigTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Single Jigs":
						return this._singleJigTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Heavy Jigs":
						return this._openHeavyTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
					case "Hornpipes":
						return this._openHornTracks.default.filter(x => x.speed === filters.speed && x.bars === filters.bars);
				}
				break;
		}

		return;
	}

	public getTracksForGradeAndCategory(grade: string, category: string): ITrackFilters | undefined
	{
		let allTracks = ({ default: this.getAllTracksForGradeAndCategory(grade, category) }); 

		this.shuffle(allTracks?.default)
		
		return allTracks;
	}

	private shuffle(array: ITrack[] | undefined) {
		if (array)
		{
			var currentIndex = array.length, temporaryValue, randomIndex;
		
			// While there remain elements to shuffle...
			while (0 !== currentIndex) {
			
				// Pick a remaining element...
				randomIndex = Math.floor(Math.random() * currentIndex);
				currentIndex -= 1;
			
				// And swap it with the current element.
				temporaryValue = array[currentIndex];
				array[currentIndex] = array[randomIndex];
				array[randomIndex] = temporaryValue;
			}
		}
		
		return array;
	}
	public setSelectedRegion(region: string): void
	{
		console.log(`[configuration]=>setSelectedRegion Region: ${region}`)
		this._selectedRegionName = region;
	}
	public getSelectedRegion(): any
	{
		if (this._selectedRegionName === "" || this._selectedRegionName === undefined || this._selectedRegionName === "not set")
		{
			//return null;
			// Going to default to UK as if we don't and the user has saved a direct link to a page, 
			// nothing will work and they won't know "why"
			this._selectedRegionName = "UK";
		}
		this._selectedRegionProfile = this._regions.default.filter(x => x.region === this._selectedRegionName);
		return this._selectedRegionProfile;
	}
	public getSelectedRegionName(): string
	{
		return this._selectedRegionName;
	}
	public getRegionFilters(): IRegions
	{
		var regions = this._regions.default.filter(x => x.isFeis === "false");
	
		var sortedRegions: Array<IRegionFilters> = regions.sort((region1,region2) => {
			if (region1.region > region2.region) {
				return 1;
			}
		
			if (region1.region < region2.region) {
				return -1;
			}
		
			return 0;
		});

		return { default: sortedRegions };
	}
	public getOnlineFeisList(): IRegions
	{
		return { default: this._regions.default.filter(x => x.isFeis === "true") };
	}
	public getAllGradeFilters(): IGradeFilters
	{
		return this._gradeFilters;
	}
	public getAllActionFilters(): IActionFilters
	{
		return this._actionFilters;
	}
	public getLightJigTracks(): ITrackFilters {
		return this._lightJigTracks;
	}
	public getSingleJigTracks(): ITrackFilters {
		return this._singleJigTracks;
	}
	public getBeginnerReelTracks(): ITrackFilters {
		return this._begReelTracks;
	}
	public getBeginnerSlipJigTracks(): ITrackFilters {
		return this._begSlipTracks;
	}
	public getBeginnerHeavyJigTracks(): ITrackFilters {
		return this._begHeavyTracks;
	}
	public getBeginnerHornpipeTracks(): ITrackFilters {
		return this._begHornTracks;
	}
	public getPrimaryReelTracks(): ITrackFilters {
		return this._primReelTracks;
	}
	public getPrimarySlipJigTracks(): ITrackFilters {
		return this._primSlipTracks;
	}
	public getPrimaryHeavyJigTracks(): ITrackFilters {
		return this._primHeavyTracks;
	}
	public getPrimaryHornpipeTracks(): ITrackFilters {
		return this._primHornTracks;
	}
	public getIntermediateReelTracks(): ITrackFilters {
		return this._intReelTracks;
	}
	public getIntermediateSlipJigTracks(): ITrackFilters {
		return this._intSlipTracks;
	}
	public getIntermediateHeavyJigTracks(): ITrackFilters {
		return this._intHeavyTracks;
	}
	public getIntermediateHornpipeTracks(): ITrackFilters {
		return this._intHornTracks;
	}
	public getOpenReelTracks(): ITrackFilters {
		return this._openReelTracks;
	}
	public getOpenSlipJigTracks(): ITrackFilters {
		return this._openSlipTracks;
	}
	public getOpenHeavyJigTracks(): ITrackFilters {
		return this._openHeavyTracks;
	}
	public getOpenHornpipeTracks(): ITrackFilters {
		return this._openHornTracks;
	}
	public getTraditionalSetTracks(): ITrackFilters {
		return this._tradSetTracks;
	}
	public getTraditionalJigTracks(): ITrackFilters {
		return this._tradJigTracks;
	}
	public getTraditionalHornpipeTracks(): ITrackFilters {
		return this._tradHornTracks;
	}
	public getShowcaseTracks(): ITrackFilters {
		return this._showcaseListing;
	}

	public getSetDanceTracks(danceName: string): ITrackFilters | undefined {
		switch(danceName)
		{
			case "Ace and Deuce":
				return JSON.parse(JSON.stringify(aceAndDeuceListing));
			case "The Blackbird":
				return JSON.parse(JSON.stringify(blackbirdListing));
			case "Blue Eyed Rascal":
				return JSON.parse(JSON.stringify(blueEyedRascalListing));
			case "Bonaparte’s Retreat":
				return JSON.parse(JSON.stringify(bonepartesRetreatListing));
			case "Downfall of Paris":
				return JSON.parse(JSON.stringify(downfallListing));
			case "Four Masters":
				return JSON.parse(JSON.stringify(fourMastersListing));
			case "Garden of Daisies":
				return JSON.parse(JSON.stringify(gardenListing));
			case "The Hunt":
				return JSON.parse(JSON.stringify(huntListing));
			case "Job of Journeywork":
				return JSON.parse(JSON.stringify(jobListing));
			case "Kilkenny Races":
				return JSON.parse(JSON.stringify(kilkennyListing));
			case "King Of The Fairies":
				return JSON.parse(JSON.stringify(kingListing));
			case "Little Heathy Hill":
				return JSON.parse(JSON.stringify(heathyListing));
			case "Lodge Road":
				return JSON.parse(JSON.stringify(lodgeListing));
			case "Madame Bonaparte":
				return JSON.parse(JSON.stringify(madameListing));
			case "Mary Ellen Bradley":
				return JSON.parse(JSON.stringify(bradleyListing));
			case "O'Doherty's Keep":
				return JSON.parse(JSON.stringify(keepListing));
			case "Piper":
				return JSON.parse(JSON.stringify(piperListing));
			case "Planxty Davis":
				return JSON.parse(JSON.stringify(davisListing));
			case "Planxty Keogh":
				return JSON.parse(JSON.stringify(keoghListing));
			case "Rambling Rake":
				return JSON.parse(JSON.stringify(ramblingListing));
			case "Rodneys Glory":
				return JSON.parse(JSON.stringify(rodneysListing));
			case "Roving Pedlar":
				return JSON.parse(JSON.stringify(rovingListing));
			case "White Blanket":
				return JSON.parse(JSON.stringify(whiteListing));
			case "Youghal Harbour":
				return JSON.parse(JSON.stringify(youghalListing));
			case "Blackthorn Stick":
				return JSON.parse(JSON.stringify(blackthornListing));
			case "The Charlady":
				return JSON.parse(JSON.stringify(charladyListing));
			case "Deep Green Pool":
				return JSON.parse(JSON.stringify(poolListing));
			case "Donegal Rambler":
				return JSON.parse(JSON.stringify(ramblerListing));
			case "Drunken Gauger":
				return JSON.parse(JSON.stringify(gaugerListing));
			case "Fiddler":
				return JSON.parse(JSON.stringify(fiddlerListing));
			case "Humours of Bandon":
				return JSON.parse(JSON.stringify(humoursListing));
			case "Hurling Boys":
				return JSON.parse(JSON.stringify(hurlingListing));
			case "Hurry The Jug":
				return JSON.parse(JSON.stringify(hurryListing));
			case "Jockey To The Fair":
				return JSON.parse(JSON.stringify(jockeyListing));
			case "Miss Browns Fancy":
				return JSON.parse(JSON.stringify(missBrownsListing));
			case "Orange Rogue":
				return JSON.parse(JSON.stringify(orangeListing));
			case "Planxty Drury":
				return JSON.parse(JSON.stringify(druryListing));
			case "Planxty Hugh ODonnell":
				return JSON.parse(JSON.stringify(hughListing));
			case "Planxty Irwin":
				return JSON.parse(JSON.stringify(irwinListing));
			case "Ri Laois":
				return JSON.parse(JSON.stringify(laoisListing));
			case "Road To Dunblane":
				return JSON.parse(JSON.stringify(dunblaneListing));
			case "Rub The Bag":
				return JSON.parse(JSON.stringify(rubListing));
			case "The Storyteller":
				return JSON.parse(JSON.stringify(storytellerListing));
			case "Three Sea Captains":
			case "Three Sea Captains Long":
				return JSON.parse(JSON.stringify(captainsListing));
			case "Vanishing Lake":
				return JSON.parse(JSON.stringify(vanishingListing));
			case "Wandering Musician":
				return JSON.parse(JSON.stringify(wanderingListing));
				
		}
	}
}
